import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { GraduationCap, ChevronRight } from "lucide-react";

export default function Lessons() {
    const [lang, setLang] = useState("english");
    const [lessons, setLessons] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        api.get(`/lessons?language=${lang}`).then((r) => setLessons(r.data));
    }, [lang]);

    return (
        <div className="max-w-7xl mx-auto px-6 py-10 space-y-8">
            <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4">
                <div>
                    <p className="eyebrow">Structured Path</p>
                    <h1 className="font-heading text-4xl sm:text-5xl font-semibold tracking-tight mt-2">Lessons</h1>
                    <p className="text-[var(--lt-muted)] mt-3 max-w-2xl">
                        Progress through carefully sequenced drills for both scripts.
                    </p>
                </div>
                <div className="inline-flex rounded-full border border-[var(--lt-border)] p-1 bg-[var(--lt-bg-2)]/60">
                    {["english", "nepali"].map((l) => (
                        <button
                            key={l}
                            onClick={() => setLang(l)}
                            className={`px-5 py-2 rounded-full text-sm font-semibold transition-all ${
                                lang === l
                                    ? "bg-[var(--lt-terracotta)] text-white"
                                    : "text-[var(--lt-muted)]"
                            }`}
                            data-testid={`language-switcher-${l}`}
                        >
                            {l === "english" ? "English" : "नेपाली"}
                        </button>
                    ))}
                </div>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
                {lessons.map((lesson, i) => (
                    <button
                        key={lesson.id}
                        onClick={() =>
                            navigate(`/practice?lang=${lang}&lesson=${lesson.id}`)
                        }
                        className="glass rounded-2xl p-6 text-left group hover:border-[var(--lt-terracotta)] transition-all"
                        data-testid={`lesson-card-${lesson.id}`}
                    >
                        <div className="flex items-center justify-between mb-4">
                            <div className="w-10 h-10 rounded-lg bg-[var(--lt-bg-2)] flex items-center justify-center">
                                <GraduationCap size={18} className="text-[var(--lt-emerald)]" />
                            </div>
                            <span className="eyebrow">Level {lesson.level}</span>
                        </div>
                        <h3
                            className={`text-xl font-bold ${
                                lang === "nepali" ? "font-nepali-heading" : "font-heading"
                            }`}
                        >
                            {lesson.title}
                        </h3>
                        <p className="text-sm text-[var(--lt-muted)] mt-2 min-h-[40px]">
                            {lesson.description}
                        </p>
                        <p
                            className={`mt-4 text-xs text-[var(--lt-muted)] line-clamp-2 ${
                                lang === "nepali" ? "font-nepali" : "font-mono-stat"
                            }`}
                        >
                            {lesson.text}
                        </p>
                        <div className="mt-4 inline-flex items-center gap-1 text-sm text-[var(--lt-terracotta)] font-semibold">
                            Start <ChevronRight size={14} />
                        </div>
                    </button>
                ))}
            </div>
        </div>
    );
}
